<div class='full-width spinner'>
    <mat-spinner></mat-spinner>
    <span>{{message}}</span>
</div>